import { render, staticRenderFns } from "./title_widget.vue?vue&type=template&id=094cd1f6&scoped=true&"
import script from "./title_widget.vue?vue&type=script&lang=js&"
export * from "./title_widget.vue?vue&type=script&lang=js&"
import style0 from "./title_widget.vue?vue&type=style&index=0&id=094cd1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094cd1f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094cd1f6')) {
      api.createRecord('094cd1f6', component.options)
    } else {
      api.reload('094cd1f6', component.options)
    }
    module.hot.accept("./title_widget.vue?vue&type=template&id=094cd1f6&scoped=true&", function () {
      api.rerender('094cd1f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widgets/title_widget.vue"
export default component.exports